export default __webpack_public_path__ + "assets/webgl/scene-20.dd62a434.glb";